import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import InputAuth from '../../components/UI/InputAuth/InputAuth';
import Button from '../../components/UI/Buttons/AuthButton/AuthButton';
import Spinner from '../../components/UI/Spinner/Spinner';
import Aux from '../hoc/Auxiliary';
import Modal from '../../components/UI/Modal/Modal';
import * as actions from '../../store/actions/index';


import classes from './Auth.css';

class Auth extends Component {

   

    state = {
        controls: {
            email: {
                elementType: 'input',
                elementConfig: {
                    type: 'email',
                    placeholder: ''
                },
                value: '',
                validation: {
                    required: true,
                    isEmail: true
                },
                valid: false,
                touched: false,
                name: 'Email'
            },
            password: {
                elementType: 'password',
                elementConfig: {
                    type: 'password',
                    placeholder: ''
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 6
                },
                valid: false,
                touched: false,
                name: 'Password'
            }  
        },
        isSignup: true,
        // loginMessage: false,
        showModal: false,
        showPassModal: false,
        showEmailModal: false
    }

    checkValidity ( value, rules ) {
        let isValid = true;
        if ( !rules ) {
            return true;
        }

        if ( rules.required ) {
            isValid = value.trim() !== '' && isValid;
        }

        if ( rules.minLength ) {
            isValid = value.length >= rules.minLength && isValid
        }

        if ( rules.maxLength ) {
            isValid = value.length <= rules.maxLength && isValid
        }

        if ( rules.isEmail ) {
            const pattern = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
            isValid = pattern.test( value ) && isValid
        }

        if ( rules.isNumeric ) {
            const pattern = /^\d+$/;
            isValid = pattern.test( value ) && isValid
        }

        return isValid;
    }

    inputChangedHandler = ( event, controlName ) => {
        const updatedControls = {
            ...this.state.controls,
            [controlName]: {
                ...this.state.controls[controlName],
                value: event.target.value,
                valid: this.checkValidity( event.target.value, this.state.controls[controlName].validation ),
                touched: true
            }
        };
        this.setState( { controls: updatedControls } );
    }


    submitHandler = (event) => {
        // event.preventDefault()
        this.props.onAuth(this.state.controls.email.value, this.state.controls.password.value)
        
        this.setState({showModal: true})
    }


    hideModalHelper = () => {

        // console.log("checking")
        this.setState({
            showEmailModal: false, 
            showPassModal: false,
            showModal: false
        })
    }

    

    

    render() {

        const formElementsArray = []
        for (let key in this.state.controls) {
            formElementsArray.push({
                id: key,
                config: this.state.controls[key]
            })
        }

        const form = formElementsArray.map( formElement => (
            <InputAuth 
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                name={formElement.config.name}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                changed={( event ) => this.inputChangedHandler( event, formElement.id )}/>
        ))

        let signin = (
            <form>
                {form}
                <div className={classes.ButtonGroup}>
                    <Button btnType="Success" clicked={this.submitHandler} disabled={false}>Log in</Button>
                </div>
            </form>
        )
           

        if (this.props.loading) {
            signin = <Spinner />
        }

        let redirect = null

        if (this.props.isAuth) {
            redirect = <Redirect to="/admin" />
        }



        let modalMessage = 'Something Went Wrong'

        if (this.props.error ) {
            
        
            if (this.props.error.message === 'INVALID_EMAIL') {
               
                modalMessage = 'Incorrect Email Address' 
            }
            else if (this.props.error.message === 'INVALID_PASSWORD') {
                modalMessage = 'Incorrect Password'
            }
    
            
        }
      

        return (
            <Aux>
                
                {redirect}
                
                <Modal show={this.props.error && this.state.showModal} modalClosed={this.hideModalHelper} >
                    <h3 className={classes.ModalText}>
                        {modalMessage}
                    </h3>
                </Modal>

                
                <h1 className={classes.Title}>Welcome!</h1>
                <hr/>
                <div className={classes.Auth}>
                    {signin}
                </div>
            </Aux>
        )
    }
}

const mapStateToProps = state => {
    return {
        loading: state.loading,
        error: state.error,
        isAuth: state.token !== null
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onAuth: (email, password) => dispatch(actions.auth(email, password))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Auth);


// WEBPACK FOOTER //
// ./src/containers/Auth/Auth.js